/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_summary_browse_file_updated24 = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `Updated ${i.date}`
};

const fr_summary_browse_file_updated24 = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `Mis à jour ${i.date}`
};

const de_summary_browse_file_updated24 = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `Aktualisiert am ${i.date}`
};

const es_summary_browse_file_updated24 = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `Actualizado ${i.date}`
};

const it_summary_browse_file_updated24 = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `Data aggiornata}`
};

const ar_summary_browse_file_updated24 = /** @type {(inputs: { date: NonNullable<unknown> }) => string} */ (i) => {
	return `تاريخ التحديث}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ date: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const summary_browse_file_updated24 = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.summary_browse_file_updated24(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("summary_browse_file_updated24", locale)
	if (locale === "en") return en_summary_browse_file_updated24(inputs)
	if (locale === "fr") return fr_summary_browse_file_updated24(inputs)
	if (locale === "de") return de_summary_browse_file_updated24(inputs)
	if (locale === "es") return es_summary_browse_file_updated24(inputs)
	if (locale === "it") return it_summary_browse_file_updated24(inputs)
	return ar_summary_browse_file_updated24(inputs)
};
export { summary_browse_file_updated24 as "SUMMARY_BROWSE_FILE_UPDATED" }